import React from 'react';

import RateCard, { Rate } from './RateCard';

export interface RateCardListProps {
  rates: Rate[];
  selectedRateId: string | null;
  onRateSelect: (id: string) => void;
  onConfirmedChange?: (rateId: string, confirmed: boolean) => void;
}

const RateCardList: React.FC<RateCardListProps> = ({
  rates,
  selectedRateId,
  onRateSelect,
  onConfirmedChange,
}) => (
  <div className="w-full flex flex-col gap-3">
    {rates.map((rate) => (
      <RateCard
        key={rate.id}
        rate={rate}
        isSelected={selectedRateId === rate.id}
        onSelect={() => onRateSelect(rate.id)}
        onConfirmedChange={(confirmed) => onConfirmedChange?.(rate.id, confirmed)}
      />
    ))}
  </div>
);

export default RateCardList;
